<template>
     <div class="defaultservicetype-registration">
        <b-form  v-show="mode === 'save' || mode === 'remove' || mode === 'read'">
             <input id="defaultservicetype-id" type="hidden" v-model="defaultservicetype.id" />
             <b-row>
                <b-col md="6" sm="12">
                    <b-form-group 
                        label="Service Name:" 
                        label-for="defaultservicetype-name_default_service_type">
                        <b-form-input 
                            id="defaultservicetype-name_default_service_type" 
                            type="text" 
                            ref="searchFocus"
                            v-model="defaultservicetype.name_default_service_type" 
                            required
                            size="sm"
                            :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            placeholder="Service name..." />
                    </b-form-group>
                </b-col>
                <b-col md="3" sm="12">
                    <div class="form-group">
                        <div class="form-check">
                            <input class="form-check-input" 
                                v-model="defaultservicetype.measured_per_hour_default_service_type" 
                                true-value="1" false-value="0" 
                                type="checkbox" 
                                id="defaultservicetype-measured_per_hour_default_service_type"
                                :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            >
                            <label class="form-check-label" for="defaultservicetype-measured_per_hour_default_service_type">
                                Measured per Hour?
                            </label>
                        </div>
                    </div>
                </b-col>  
                <b-col md="3" sm="12">
                    <div class="form-group">
                        <div class="form-check">
                            <input class="form-check-input" 
                                v-model="defaultservicetype.blocked_default_service_type" 
                                true-value="1" false-value="0" 
                                type="checkbox" 
                                id="defaultservicetype-blocked_default_service_type"
                                :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            >
                            <label class="form-check-label" for="defaultservicetype-blocked_default_service_type">
                                Blocked?
                            </label>
                        </div>
                    </div>
                </b-col>  

             </b-row>

         </b-form>
                <b-row>                   
                <b-col xs="12">
                    <b-button  
                        title="Add" 
                        size="sm" 
                        class="mt-2 mb-2 fa fa-plus" 
                        variant="dark" 
                        v-show="mode !== 'save' && mode !== 'remove'"
                        @click="alterModo"></b-button>
                    <b-button  
                        title="Save"  
                        size="sm" 
                        variant="dark" 
                        class="mt-2 mb-2 ml-2 fa fa-save" 
                        v-if="mode === 'save'"
                        @click="save"></b-button>
                    <b-button  
                        title="Delete" 
                        size="sm" 
                        variant="dark" 
                        class="mt-2 mb-2 ml-2 fa fa-trash" 
                        v-if="mode === 'remove'"
                        @click="remove"></b-button>
                    <b-button  
                        title="Back" 
                        size="sm" 
                        variant="dark" 
                        class="mt-2 mb-2 ml-2 fa fa-ban"  
                        v-if="mode === 'remove' || mode === 'save' || mode === 'read' "
                        @click="reset"></b-button>
                    <b-button  
                    size="sm" 
                    title="Search" 
                    class="mt-2 mb-2 ml-2 fa fa-search" 
                    @click="[loadParts(),toggleBusy(),showTable = !showTable]" 
                    variant="dark" 
                    v-show="mode !== 'save' && mode !== 'remove'"
                    >
                    </b-button>
                </b-col>
            </b-row>
            <b-row v-show="mode !== 'save' && mode !== 'remove'">
                <div class="col-sm-6">
                    <b-form-group> 
                    <input size="lg" type="text" icon="search" v-model="search" 
                    placeholder="Search by Service name " class="form-control">                  
                    </b-form-group>
                </div>
            <transition  name="slide" type="animation" appear>       
                <b-table 
                        :busy="isBusy"  
                        class="table-responsive" 
                        hover 
                        key="slide"  
                        head-variant="light" 
                        :per-page="perPage" 
                        :current-page="currentPage" 
                        :items="filteredList" 
                        :fields="fields">
                     <template v-slot:table-busy>
                        <div class="text-center text-info my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>loading...</strong>
                        </div>
                    </template>
                    <template v-slot:cell(actions)="data">
                        <b-button 
                                title="View" 
                                size="sm" 
                                variant="light" 
                                @click="loadPart(data.item, 'read')" 
                                class="mr-2 mt-2">
                            <i class="fa fa-drivers-license-o"></i>
                        </b-button>
                        <b-button 
                            title="Edit" 
                            size="sm" 
                            variant="light" 
                            @click="loadPart(data.item)" class="mr-2 mt-2">
                            <i class="fa fa-pencil"></i>
                        </b-button>
                        <b-button 
                            title="Delete" 
                            size="sm" 
                            variant="light" 
                            @click="loadPart(data.item, 'remove')" 
                            class="mr-2 mt-2">
                            <i class="fa fa-trash"></i>
                        </b-button>
                    </template>
                </b-table>
            </transition>
            <b-pagination 
              v-model="currentPage" 
              :per-page="perPage"
              :total-rows="rows">
              </b-pagination> 
            </b-row>
      </div>
</template>

<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
var moment = require('moment')

export default {
         name: 'DefaultServiceType',
            directives: {moment},
                data: function() {
                return {
                    mode: 'insert',
                    search: '',
                    defaultservicetype: {},
                    defaultservicetypes: [],
                    showTable: false,
                    showSearch: true,
                    isBusy: false,
                    currentPage: 1,
                    perPage: 5,
                    fields: [
                        { key: 'name_default_service_type', label: 'Service Name', sortable: true },
                        { key: 'measured_per_hour_default_service_type', label: 'Measured Hour', sortable: false,
                            formatter: value => value ? 'Yes' : 'No' },
                        { key: 'blocked_default_service_type', label: 'Blocked', sortable: false,
                            formatter: value => value ? 'Yes' : 'No' },
                        { key: 'actions', label: 'Ações', variant: 'secondary' }
                    ]
                }
            },
            computed: {
                user(){
                    return this.$store.state.user
                },
                compan(){
                    return this.$store.state.compan
                },
                filteredList() {
                return this.defaultservicetypes.filter(defaultservicetype => {
                return defaultservicetype.name_default_service_type.toLowerCase().includes(this.search.toLowerCase())
                    })
                },
                icon() {
                    return this.showTable ? "fa-retweet" : "fa-search"
                },
                 rows() {
                    return this.defaultservicetypes.length
                }
            },
            methods: {
            formatDate (date) {
                return moment.utc(date).format('YYYY-MM-DD')
            },
            toggleBusy() {
                this.isBusy = !this.isBusy
            },
            loadParts() {
                const url = `${baseApiUrl}/defaultservicetypesbycompany/${this.compan.id}`
                axios.get(url).then(res => {
                    this.defaultservicetypes = res.data
                     this.isBusy = false
            })
            },
            reset() {
                this.mode = 'insert'
                this.loadParts()
            },
            alterModo() {
                        this.mode = 'save'
                        this.defaultservicetype = {}
                        this.$refs.searchFocus.focus();
                },
            save() {

          
                    this.defaultservicetype = {
                        ...this.defaultservicetype,
                        company_id_default_service_type: this.compan.id,
                        user_id_default_service_type: this.user.id
                    }
                   
                const method = this.defaultservicetype.id ? 'put' : 'post'
                const id = this.defaultservicetype.id ? `/${this.defaultservicetype.id}` : ''
                axios[method](`${baseApiUrl}/defaultservicetypes${id}`, this.defaultservicetype)
                    .then(() => {
                        this.$toasted.global.defaultSuccess()
                        this.reset()
                    })
                    .catch(showError)
            },
            remove() {
                const id = this.defaultservicetype.id
                axios.delete(`${baseApiUrl}/defaultservicetypes/${id}`)
                    .then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.reset()
                    })
                    .catch(showError)
            },
            loadPart(defaultservicetype, mode = 'save') {
                this.mode = mode
                this.defaultservicetype = { ...defaultservicetype }
                this.$refs.searchFocus.focus();
            }
                
             },
            mounted() {
                this.showTable = true
                this.loadParts()
            }
    }       
</script>

<style>

     .defaultservicetype-registration label {
        font-size: 0.75rem;
        color: black;
    }

    .defaultservicetype-registration select{
        font-size: 0.75rem;
    }
    .defaultservicetype-registration input{
        font-size: 0.75rem;
    }
    .defaultservicetype-registration textarea{
        font-size: 0.75rem;
    }
    .defaultservicetype-registration button{
        font-size: 0.75rem;
    }
    .defaultservicetype-registration table{
        font-size: 0.75rem;
    }

    @keyframes slide-in {
    from {transform: translateY(40px);}
    to {transform: translateY(0);}
    }

    @keyframes slide-out {
        from {transform: translateY(0);}
        to {transform: translateY(40px);}
    }

    .slide-enter-active {
    animation: slide-in 1s ease;
        transition: opacity 1s;
    }

    .slide-leave-active {
        animation: slide-out 1s ease;
        transition: opacity 1s;
    }

    .slide-enter, .slide-leave-to{
        opacity: 0;
    }

    .fade-enter, .fade-leave-to{
    opacity: 0;
    }

    .fade-enter-active, .fade-leave-active{
    transition: opacity 1s;
    }

</style>
